export const THREAT_ACTOR = 'threat actor';
export const THREAT_ACTOR_GROUP = 'threat actors group';
export const TOOL = 'tool';
export const TECHNIQUE = 'technique';
export const CAMPAIGN = 'campaign';
export const INDUSTRY = 'industry';

// export const DOMAIN = 'domain';
export const IP = 'ip';
export const ORGANIZATION = 'organization';
export const SUBDOMAIN = 'subdomain';
export const S3_BUCKET = 's3_bucket';
export const GOOGLE_CLOUD_STORAGE = 'google_cloud_storage';
export const AZURE_STORAGE_BLOB = 'azure_storage_blob';
export const AZURE_DATA_LAKE = 'azure_data_lake';
export const AWS_ACCOUNT = 'aws_account';
export const CLOUD_STORAGE = 'cloud_storage';
export const CLOUD_ACCOUNT = 'cloud_account';

export const PRODUCT = 'product';
export const VENDOR = 'vendor';
export const TECHNOLOGY = 'technology';
export const KEYWORD = 'keyword';
export const BIN_NUMBER = 'bin number';
export const DOMAIN = 'domain';
export const URL = 'url';
export const IP_ADDRESS = 'IP address';
export const EMAIL = 'email';
export const PERSON = 'person';
export const MOBILE_APPLICATION = 'mobile application';
export const YOUTUBE_ACCOUNT = 'YouTube account';
export const FACEBOOK_ACCOUNT = 'Facebook account';
export const TWITTER_ACCOUNT = 'Twitter account';
export const VK_ACCOUNT = 'VK account';
export const LINKEDIN_ACCOUNT = 'LinkedIn account';
export const INSTAGRAM_ACCOUNT = 'Instagram account';
export const SENSITIVE_CODE_IDENTIFIER = 'sensitive code identifier';
export const EMPLOYEE_LOGIN_INTERFACE = 'employee login interface';
export const COMPANY = 'company';
export const BRAND = 'brand'; // custom type created on UI side (under the hood contains two types: company and product)
export const DOCUMENT_IDENTIFIER = 'document identifier';

export const ALL_ENTITY_TYPES = {
  keyword: 'keyword',
  'bin-number': 'bin-number',
  domain: 'domain',
  url: 'url',
  'ip-address': 'ip-address',
  email: 'email',
  'mobile-application': 'mobile-application',
  person: 'person',
  'sensitive-code-identifier': 'sensitive-code-identifier',
  'employee-login-interface': 'employee-login-interface',
  company: 'company',
  product: 'product',
  'document-identifier': 'document-identifier'
};

export const ENTITY_TYPE_TRANSLATION = {
  [THREAT_ACTOR]: 'threat-actor',
  [THREAT_ACTOR_GROUP]: 'threat-actor-group',
  [TOOL]: 'tool',
  [TECHNIQUE]: 'technique',
  [CAMPAIGN]: 'campaign',
  [INDUSTRY]: 'industry',
  [VENDOR]: 'vendor',
  [TECHNOLOGY]: 'technology',
  [KEYWORD]: 'keyword',
  [BIN_NUMBER]: 'bin-number',
  [DOMAIN]: 'domain',
  [URL]: 'url',
  [IP_ADDRESS]: 'ip-address',
  [EMAIL]: 'email',
  [YOUTUBE_ACCOUNT]: 'youtube-account',
  [TWITTER_ACCOUNT]: 'twitter-account',
  [VK_ACCOUNT]: 'vk-account',
  [LINKEDIN_ACCOUNT]: 'linkedin-account',
  [INSTAGRAM_ACCOUNT]: 'instagram-account',
  [FACEBOOK_ACCOUNT]: 'facebook-account',
  [MOBILE_APPLICATION]: 'mobile-application',
  [PERSON]: 'person',
  [SENSITIVE_CODE_IDENTIFIER]: 'sensitive-code-identifier',
  [EMPLOYEE_LOGIN_INTERFACE]: 'employee-login-interface',
  [COMPANY]: 'company', // UI = 'brand'
  [PRODUCT]: 'product', // UI = 'brand'
  [BRAND]: 'brand', // custom type created on UI side (under the hood contains two types: company and product)
  [DOCUMENT_IDENTIFIER]: 'document-identifier'
};

export const KNOWLEDGE_BASE_ENTITY_TYPES = [THREAT_ACTOR, THREAT_ACTOR_GROUP, TOOL, TECHNIQUE, CAMPAIGN];

export const CREATABLE_ASSET_ENTITY_TYPES = [
  PRODUCT,
  KEYWORD,
  BIN_NUMBER,
  DOMAIN,
  URL,
  IP_ADDRESS,
  EMAIL,
  YOUTUBE_ACCOUNT,
  FACEBOOK_ACCOUNT,
  TWITTER_ACCOUNT,
  VK_ACCOUNT,
  LINKEDIN_ACCOUNT,
  INSTAGRAM_ACCOUNT,
  MOBILE_APPLICATION,
  PERSON,
  SENSITIVE_CODE_IDENTIFIER,
  EMPLOYEE_LOGIN_INTERFACE
];

export const LISTABLE_ASSET_ENTITY_TYPES = [...CREATABLE_ASSET_ENTITY_TYPES, COMPANY];

export const ASSET_LINKABLE_ENTITY_TYPES = [COMPANY, PRODUCT, PERSON];

export const NETWORK_AND_URL_ENTITY_TYPES = [URL, DOMAIN, FACEBOOK_ACCOUNT, TWITTER_ACCOUNT, YOUTUBE_ACCOUNT];

export const KNOWLEDGE_BASE_ENTITY_TYPES_NAME = 'KNOWLEDGE_BASE_ENTITY_TYPES_NAME';
export const ASSET_ENTITY_TYPES_NAME = 'ASSET_ENTITY_TYPES_NAME';

export const ENTITY_TYPES = [ASSET_ENTITY_TYPES_NAME, KNOWLEDGE_BASE_ENTITY_TYPES_NAME];
export const ENTITY_TYPES_BY_NAME = {
  [KNOWLEDGE_BASE_ENTITY_TYPES_NAME]: KNOWLEDGE_BASE_ENTITY_TYPES,
  [ASSET_ENTITY_TYPES_NAME]: [...CREATABLE_ASSET_ENTITY_TYPES, COMPANY]
};
